export default __webpack_public_path__ + "static/media/Screenshot_4-1736524901006.8a0e0519.png";